import React from 'react';
import { motion } from 'framer-motion';
import { ProductImage } from './ProductImage';
import { Package, Settings, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductReveal() {
  const includes = ['Protocolos de evaluación profesional', 'Planillas listas para usar', 'Sistemas de seguimiento clínico', 'Métodos organizados y replicables', 'Estructuras aplicables desde el día 1'];
  const howItWorks = ['Evaluás con estructura', 'Registrás datos correctamente', 'Seguís el progreso del paciente', 'Ajustás con precisión clínica'];
  return <section className="py-20 px-4 bg-slate-900 border-t border-slate-800" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-109">
          <span className="text-amber-500 font-bold text-xl tracking-wider uppercase mb-2 block" data-id="element-110">
            🔥 Presentamos…
          </span>
          <h2 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-200 mb-6 drop-shadow-sm" data-id="element-111">
            KIT ORTOPEDISTA PRO
          </h2>
          <p className="text-2xl text-white font-medium mb-4" data-id="element-112">
            Un sistema profesional diseñado para transformar tu forma de
            trabajar.
          </p>
          <p className="text-lg text-slate-400 mb-8" data-id="element-113">
            No es teoría. No es otro curso más.
          </p>
          <div className="inline-block bg-amber-500/10 border border-amber-500/30 px-6 py-3 rounded-full" data-id="element-114">
            <p className="text-xl font-bold text-amber-400" data-id="element-115">
              👉 Es implementación directa.
            </p>
          </div>
        </motion.div>

        <div className="mb-20" data-id="element-116">
          <ProductImage className="max-w-2xl" data-id="element-117" />
          <p className="text-center text-xl md:text-2xl text-slate-300 font-semibold mt-6" data-id="element-118">
            Sistema profesional de evaluación y seguimiento en ortopedia
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-2xl border border-slate-800" data-id="element-120">
            <div className="flex items-center gap-3 mb-6" data-id="element-121">
              <Package className="w-8 h-8 text-teal-400" data-id="element-122" />
              <h3 className="text-2xl font-bold text-white" data-id="element-123">¿Qué incluye?</h3>
            </div>
            <p className="text-slate-300 mb-6" data-id="element-124">
              Un sistema completo dividido en 10 tomos prácticos, que incluyen:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-125">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-126">
                  <Check className="w-6 h-6 text-teal-500 flex-shrink-0" data-id="element-127" />
                  <span className="text-slate-200" data-id="element-128">{item}</span>
                </li>)}
            </ul>
            <p className="font-bold text-amber-400 bg-amber-950/30 p-4 rounded-lg border border-amber-900/50" data-id="element-129">
              👉 Todo pensado para que no tengas que crear nada desde cero.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-2xl border border-slate-800" data-id="element-130">
            <div className="flex items-center gap-3 mb-6" data-id="element-131">
              <Settings className="w-8 h-8 text-teal-400" data-id="element-132" />
              <h3 className="text-2xl font-bold text-white" data-id="element-133">¿Cómo funciona?</h3>
            </div>
            <p className="text-slate-300 mb-6" data-id="element-134">
              El sistema es simple, pero poderoso:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-135">
              {howItWorks.map((item, i) => <li key={i} className="flex items-center gap-3 bg-slate-900 p-3 rounded-lg border border-slate-800" data-id="element-136">
                  <div className="w-8 h-8 rounded-full bg-teal-900/50 text-teal-400 flex items-center justify-center font-bold border border-teal-800/50" data-id="element-137">
                    {i + 1}
                  </div>
                  <span className="text-slate-200 font-medium" data-id="element-138">{item}</span>
                </li>)}
            </ul>
            <p className="font-bold text-teal-400 bg-teal-950/30 p-4 rounded-lg border border-teal-900/50" data-id="element-139">
              👉 Resultado: pacientes que mejoran más rápido y con mayor
              claridad.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-140">
          <CTAButton data-id="element-141" />
        </motion.div>
      </div>
    </section>;
}